import { IconArrowRight, Link } from '@cmpsr/components';

type CancerMenuItemProps = {
  text: string;
  onClick: () => void;
};

export default function CancerMenuItem(props: CancerMenuItemProps) {
  return (
    <Link
      variant="link-accent"
      justifyContent="space-between"
      w="100%"
      px={0}
      py={2}
      color="white"
      fontWeight="400"
      trailingIcon={<IconArrowRight />}
      onClick={props.onClick}
    >
      {props.text}
    </Link>
  );
}
